import { Injectable } from '@angular/core';
import { io } from "socket.io-client";
import { environment as env } from 'src/environments/environment';
import { CustomerService } from './api/customer.service';
import { MaintenanceService } from './api/maintenance.service';
import { ToastService } from './toast.service';
import uniqid from 'uniqid';

@Injectable({
	providedIn: 'root'
})
export class SocketioService {

	socket:any = null;
	selfRoomName:string = '';
	isJoined:boolean = false;

	/** 
	 * event callback will be saved here
	 */
	callbacks:any = {};

	constructor(
		public customerService: CustomerService,
		public toastService: ToastService,
		public maintenanceService: MaintenanceService
	) {
		this.socketConnect();
	}

	/**
	 * do the socket connection
	 */
	socketConnect(){
		return new Promise(resolve => {
			this.socket = io(env.socket_url);

			this.socket.on('connect', f => {
				this.customerService.storage.get('user').then(user => {		
					if(user){
						this.init();
						this.socket.io.on("reconnect", () => {
							this.init();
						});
						resolve(true);
					}
					else {
						this.initOn(false);
						resolve(false);
					}
				});

				// this.setTabUniqId();
				// this.socket.io.on("reconnect", () => {
				// 	this.setTabUniqId();
				// });
			});
		});
	}

	// setTabUniqId(){
	// 	this.customerService.storage.get('tab_uniqid_ids').then((uniqIds:any) => {
	// 		let _tabUniqIds = [];
	// 		if(uniqIds){
	// 			_tabUniqIds = uniqIds;
	// 		}

	// 		let uniqId = uniqid();
	// 		this.socket.emit('set_browser_tab_uniqid', uniqId, (result) => {
	// 			_tabUniqIds.push(result);
	// 			this.customerService.storage.setLocal('tab_uniqid_ids', _tabUniqIds, 0);
	// 		});
	// 	});
	// }

	init(){
		this.isJoined = false;
		if(this.customerService.customer){
			this.joinSelfRoom();
			this.initOn();
		}
		else {
			this.customerService.getLogedInCustomer().then(() => {
				this.joinSelfRoom();
				this.initOn();
			});
		}
	}

	/** 
	 * join the in a private user room
	 * where only the specific user can listen for the event 
	 */
	joinSelfRoom(){
		if(!this.isJoined){
			if(this.customerService.customer){
				this.selfRoomName = 'self_room_2_' + this.customerService.customer.id;
				this.socket.emit('join_room', this.selfRoomName);
				this.isJoined = true;
			}
		}
	}

	joinOrderRoom(orderId:any){
		let roomName = 'order_room_' + orderId;
		this.socket.emit('join_room', roomName);

		// let checkCustomer = setInterval(f => {
		// 	if(this.customerService.customer){
		// 		let roomName = 'order_room_' + orderId;
		// 		this.socket.emit('join_room', roomName);
		// 		clearInterval(checkCustomer);
		// 	}
		// });
	}

	leaveOrderRoom(orderId:any){
		let roomName = 'order_room_' + orderId;
		this.socket.emit('leave_room', roomName);
	}

	initOn(isUser:boolean = true){
		this.socket.removeAllListeners();
		setTimeout(() => {
			if(isUser){
				this.addEvent('address_save');
				this.addEvent('selected_address_change');
				this.addEvent('selected_shipping_method_change');
				this.addEvent('payment_method_change');
				// this.addEvent('toggle_wallet_usage');
				this.addEvent('checkout_success_place_order');
				this.addEvent('checkout_apply_voucher');
				this.addEvent('checkout_delete_address');
				this.addEvent('change_default_address');
				this.addEvent('order_saved');
				this.addEvent('upload_artwork');
			}

			/**
			 * below is the event that can be emitted even if not logged in
			 */
			this.addEvent('push_notification');
			this.addCallback('push_notification', '*', (data) => {
				this.initPush(data);
			});
		}, 500);
	}

	initPush(data:any){
		try {
			let type:string = data['type'];
			switch (type) {
				case 'maintenance_flag_message': 
					this.maintenanceService.getMaintenanceMessage();
					break;
				default:
					break;
			}
		} catch (error) {
			console.error(error);
			/** do nothing for now */
		}
	}

	addEvent(event){
		this.socket.on(event, (data) => {
			this.runCallbacks(event, data);
		});
	}

	runCallbacks(event, data){
		if(typeof this.callbacks[event] != 'undefined'){
			let callbacks = this.callbacks[event];

			for (var key in callbacks) {
				if (callbacks.hasOwnProperty(key)) {
					let callback = callbacks[key];
					callback(data);
				}
			}
		}
	}

	/**
	 * 
	 * @param event string socket event
	 * @param fromPage the page location of the callback 
	 * @param callback a function that will be called when the event is received
	 */
	addCallback(event:string, fromPage:string, callback:any){
		/**
		 * before we are adding the event in the initOn() method
		 * but will be needing to add a new event every time we have to add one
		 * with this we can now add an event if it is not exist
		 * added 4-11-2022
		 */
		if (typeof this.socket._callbacks["$" + event] == 'undefined') {
			this.addEvent(event);
		}

		if(typeof this.callbacks[event] == 'undefined'){
			this.callbacks[event] = {};
		}

		this.callbacks[event][fromPage] = callback;
	}

	/**
	 * 
	 * @param event string socket event
	 * @param fromPage the page location of the callback 
	 */
	removeCallback(event:string, fromPage:string){
		if(typeof this.callbacks[event] != 'undefined'){
			if(typeof this.callbacks[event][fromPage] != 'undefined'){
				delete this.callbacks[event][fromPage];
			}	
		}
	}

	/**
	 * emit to self private room, assume that the user is log in
	 * @param event 
	 * @param data 
	 * @param callback 
	 */
	emitToSelf(event:string, data:any, callback:any = null){
		let jsonData = {
			emit_to: this.selfRoomName,
			data: {
				socket_id: this.socket.id,
				data: data
			}
		}
		this.socket.emit(event, jsonData, callback);
	}

	/**
	 * emit to room name
	 * @param event 
	 * @param data 
	 * @param roomName 
	 * @param callback 
	 */
	emitToRoom(event:string, data:any, roomName:any, callback:any = null){
		let jsonData = {
			emit_to: roomName,
			data: {
				socket_id: this.socket.id,
				data: data
			}
		}
		this.socket.emit(event, jsonData, callback);
	}
}
